<template>
  <div class="lv_flexalign_center act_layout">
    <div
      class="act_button"
      :class="{ actived: actived === 1 }"
      @click="change(true)"
    >
      显示
    </div>
    <div
      class="act_button"
      :class="{ actived: actived === 2 }"
      @click="change(false)"
    >
      隐藏
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      actived: 1,
      id: "",
    };
  },
  methods: {
    init(item) {
      this.id = item ? item.id : "";
      this.actived = item && item.showStem === false ? 2 : 1;
    },
    change(status) {
      this.actived = status ? 1 : 2;
      if (!this.id) {
        return;
      }
      this.$bus.$emit("setStemVisible", {
        id: this.id,
        value: status,
      });
    },
  },
};
</script>
